import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WholeViewPictureComponent } from '@libraries/component-library';
import { CanActivateSuccessGuard, CheckQuestionUrlPrefilledGuard } from '../guards';
import { ImageDataResolver } from './../guards/imageData.resolver';
import { AddressesComponent } from './addresses/addresses.component';
import { CalculateExistingImprovementMonthlyCostComponent } from './calculate-existing-improvement-monthly-cost/calculate-existing-improvement-monthly-cost.component';
import { CalculateOtherImprovementMonthlyCostComponent } from './calculate-other-improvement-monthly-cost/calculate-other-improvement-monthly-cost.component';
import { ComingSoonSuccessComponent } from './coming-soon-success/coming-soon-success.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { CongratulationsWaitlistComponent } from './congratulations-waitlist/congratulations-waitlist.component';
import { HeaderWrapperComponent } from './header-wrapper/header-wrapper.component';
import { MayBeEligibleComponent } from './may-be-eligible/may-be-eligible.component';
import { QuestionsComponent } from './questions/questions.component';
import { SuccessComponent } from './success/success.component';

const routes: Routes = [
  {
    path: '',
    outlet: 'header',
    component: HeaderWrapperComponent,
  },
  {
    path: '',
    outlet: 'left',
    component: QuestionsComponent,
    canActivate: [CheckQuestionUrlPrefilledGuard],
  },
  {
    path: '',
    outlet: 'right',
    component: WholeViewPictureComponent,
    data: {
      primaryOutlet: 'left',
      depth: 1,
    },
    resolve: {
      imageData: ImageDataResolver,
    },
  },
  {
    path: 'addresses',
    outlet: 'right',
    component: AddressesComponent,
    data: { primaryOutlet: 'right', depth: 2 },
  },
  {
    path: 'may-be-eligible',
    outlet: 'right',
    component: MayBeEligibleComponent,
    data: { primaryOutlet: 'right', depth: 2 },
  },
  {
    path: 'coming-soon',
    outlet: 'right',
    component: ComingSoonComponent,
    data: { primaryOutlet: 'right', depth: 3 },
  },
  {
    path: 'coming-soon-success',
    outlet: 'right',
    component: ComingSoonSuccessComponent,
    data: { primaryOutlet: 'right', depth: 4 },
  },
  {
    path: 'congratulations-unsecured',
    outlet: 'right',
    component: CongratulationsWaitlistComponent,
    data: { primaryOutlet: 'right', depth: 3 },
  },
  {
    path: 'success',
    outlet: 'right',
    component: SuccessComponent,
    data: { primaryOutlet: 'right', depth: 4 },
    canActivate: [CanActivateSuccessGuard],
  },
  {
    path: 'success-improvement',
    component: CalculateExistingImprovementMonthlyCostComponent,
  },
  {
    path: 'success-other',
    component: CalculateOtherImprovementMonthlyCostComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PrequalQuestionsRoutingModule {}
